import {
  GET_ASSIGNED_DOCUMENT,
  GET_DOCUMENT_ASSOCIATIONS,
  GET_DOCUMENT_EXTRACTION_FILLED_FIELD_IDS,
  GET_DOCUMENT_EXTRACTION_FILLED_FIELDS,
  GET_DOCUMENT_EXTRACTION_REQUEST,
  GET_DOCUMENT_HISTORY,
} from '../actions';

const initialState = {
  assigned: null,
  availableDocumentsCount: 0,
  sessionId: null,
  filledExtractionFieldIds: [],
  filledExtractionFields: [],
  filledExtractionFieldsDocumentId: null,
  // Scalar fields (legacy single-select, retained for backward compatibility)
  borrowerId: null,
  incomeId: null,
  assetId: null,
  propertyId: null,
  liabilityId: null,
  // Collection fields (multi-select, Skynet.Documents #393)
  borrowerIds: [],
  incomeIds: [],
  assetIds: [],
  propertyIds: [],
  liabilityIds: [],
  history: [],
};

const documentReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case GET_DOCUMENT_HISTORY:
      return { ...state, history: payload };

    case GET_ASSIGNED_DOCUMENT: {
      const { document: assigned, availableDocumentsCount } = payload;

      return {
        ...state,
        assigned,
        availableDocumentsCount,
      };
    }

    case GET_DOCUMENT_EXTRACTION_REQUEST: {
      const { document: assigned, id: sessionId } = payload;

      return {
        ...state,
        assigned,
        sessionId,
      };
    }

    case GET_DOCUMENT_EXTRACTION_FILLED_FIELD_IDS:
      return { ...state, filledExtractionFieldIds: payload };

    case GET_DOCUMENT_EXTRACTION_FILLED_FIELDS: {
      const filledExtractionFieldIds = payload.map(
        ({ documentExtractionFieldId }) => documentExtractionFieldId,
      );

      return {
        ...state,
        filledExtractionFieldIds,
        filledExtractionFields: payload,
        filledExtractionFieldsDocumentId: meta?.documentId ?? null,
      };
    }

    case GET_DOCUMENT_ASSOCIATIONS:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default documentReducer;
